import { render, staticRenderFns } from "./ProgramEvent.vue?vue&type=template&id=711e8032"
import script from "./ProgramEvent.vue?vue&type=script&lang=js"
export * from "./ProgramEvent.vue?vue&type=script&lang=js"
import style0 from "./ProgramEvent.vue?vue&type=style&index=0&id=711e8032&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports